var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisibleFooter,
            expression: "isVisibleFooter",
          },
        ],
        staticClass: "fade-footer fade-element",
        on: { click: _vm.handleFooterAction },
      },
      [
        _c("div", { staticClass: "left-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("fadeFooterButton.cumulative")))]),
          _c("span", { staticClass: "highlight" }, [
            _c("span", { staticClass: "font-large" }, [
              _vm._v(_vm._s(_vm.linkedNovelCount)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("fadeFooterButton.worksUnit")))]),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("fadeFooterButton.proposing")))]),
        ]),
        _c("div", { staticClass: "right-button" }, [
          _vm._v(_vm._s(_vm.$t("fadeFooterButton.tryButton"))),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }